import { z } from 'zod';

export const ErrorSensorSchema = z.object({
  type: z.literal('error'),
  message: z.string(),
});

export const LocationSensorSchema = z.object({
  type: z.literal('location'),
  latitude: z.number(),
  longitude: z.number(),
  altitude: z.number().nullable(),
  accuracy: z.number(),
  capturedAt: z.string().datetime(),
});

export const SensorReadingSchema = z.discriminatedUnion('type', [
  LocationSensorSchema,
  ErrorSensorSchema,
  // Future sensor types can be added here
]);

export const SensorReadingsSchema = z.array(SensorReadingSchema);

export type SensorReading = z.infer<typeof SensorReadingSchema>;
export type SensorReadings = z.infer<typeof SensorReadingsSchema>;
export type LocationSensor = z.infer<typeof LocationSensorSchema>;
export type ErrorSensor = z.infer<typeof ErrorSensorSchema>;
